export enum RegexType {
  EMAIL_VALIDATOR ='EMAIL_VALIDATOR',
  HEKATRON_PHONE_NUMBER_VALIDATION ='HEKATRON_PHONE_NUMBER_VALIDATION',
  NUMBERS_ONLY='NUMBERS_ONLY',
}
